import getBreakpoint from "selectors/breakpoint/getBreakpoint";
import isLandscape from "utils/Orientation";
import { createSelector } from "reselect";
import getCssValueFromDefinition from "utils/getCssValueFromDefinition";

const getViewportHeight = (state) => state.viewport.dimensions.height;
const getViewportWidth = (state) => state.viewport.dimensions.width;

const getFontSizeIconLarge = createSelector(
  [getBreakpoint, getViewportHeight, getViewportWidth],
  (
    breakpoint,
    // `viewportHeight` is unused but is necessary to force the selector to recalculate
    viewportHeight,
    // `viewportWidth` is unused but is necessary to force the selector to recalculate
    viewportWidth,
  ) => {
    const breakpointName = breakpoint.breakpoint;
    const landscape = isLandscape({
      height: viewportHeight,
      width: viewportWidth,
    });

    return getCssValueFromDefinition({
      breakpoint: breakpointName,
      cssKey: "height",
      landscape,
      property: "controls-padding",
    });
  },
);

export default getFontSizeIconLarge;
